import React, { ReactElement } from "react";
import { Checkbox } from "@components/form";
import clsx from "clsx";

interface IProps {
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => void;
  companyTypesList: number[];
  interestCompanyTypes: number[];
  editMode: boolean;
  isUseNetworking: boolean;
  hasError?: boolean;
}

const CompanyType = ({
  companyTypesList,
  interestCompanyTypes,
  onChange,
  editMode,
  isUseNetworking,
  hasError = false,
}: IProps): ReactElement => {
  return (
    <div className="profile-netw-step">
      <div
        className={clsx("profile-netw-step__body", {
          "profile-netw-step--error": editMode && hasError,
        })}
      >
        <div className="profile-netw-step__body-header">
          <p className="profile-netw-step__title">
            {!isUseNetworking && <span className="text-[#185ADB]">* </span>}С
            компаниями какого типа вы ищете контакты?
          </p>
          {!isUseNetworking && editMode && (
            <p className="profile-netw-step__desc">
              Это <span className="underline">обязательный пункт</span>.
              Выберете хотя бы одно значение:
            </p>
          )}
        </div>

        {editMode ? (
          <div className="profile-netw-step__main profile-netw-step__main--checkbox-list">
            {companyTypesList?.map((Item: any, index: number) => (
              <Checkbox
                key={index}
                name="languages"
                type="profile"
                placeholder={Item.name}
                value={Item.id}
                hiddenInput
                checked={interestCompanyTypes?.includes(Item.id)}
                onChange={onChange}
              />
            ))}
          </div>
        ) : (
          interestCompanyTypes?.length > 0 &&
          companyTypesList?.some((Item: any) =>
            interestCompanyTypes.includes(Item.id)
          ) && (
            <div className="profile-netw-step__main profile-netw-step__main--item-list">
              {companyTypesList?.map(
                (Item: any, index: number) =>
                  interestCompanyTypes.includes(Item.id) && (
                    <div key={index} className="profile-netw-step__main-item">
                      {Item.name}
                    </div>
                  )
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default CompanyType;
